import moment from 'moment';
import iconFormatter from '../../../../pages/private/utils/iconFormatter';

export default function TableConfig(searchPropsFactory) {
  return {
    columns: [
      {
        dataIndex: 'name',
        title: 'Название',
        ...searchPropsFactory('name', 'Названию'),
      },
      {
        dataIndex: 'path',
        title: 'Путь',
        ...searchPropsFactory('path', 'Пути'),
      },
      {
        dataIndex: 'date',
        title: 'Дата копии',
        ...(() => {
          const searchProps = searchPropsFactory('date', 'Дате копии');
          return {
            ...searchProps,
            onFilter: (value, record) => {
              const formattedDate = moment(record.date).format('DD.MM.YYYY HH:mm');
              return formattedDate.toLowerCase().includes(value.toLowerCase());
            },
            render: (text, rec) => {
              const formattedDate = moment(rec.date).format('DD.MM.YYYY HH:mm');
              return searchProps.render ? searchProps.render(formattedDate) : <p>{formattedDate}</p>;
            },
          };
        })(),
      },
      {
        dataIndex: 'Settings',
        title: ' ',
        render: () => iconFormatter({ write: true, update: false, download: true }),
        width: 100,
      },
    ],
  };
}
